export default __webpack_public_path__ + "static/media/9d.807a943a.svg";